export default "__VITE_ASSET__07558e6a__"